module.exports = __webpack_public_path__ + "static/media/Information.6dc6d7a7.svg";